import React, { useCallback, useEffect, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getConfig } from '../get-import-config'
import BaseActionButton from '../../Page/BaseActionButton'
import Modal from '../../Modal'
import ImportOfficialsContent from './ImportOfficialsContent'

/**
 * Import Officials onto an organization's or a competition's Officials list
 * (`entityType` is ENTITY_TYPES.org or ENTITY_TYPES.schedule).
 */
const ImportOfficials = ({
  teamId,
  teamName,
  teamRosterId,
  onSuccess,
  entityType,
  entityId,
}) => {
  const queryClient = useQueryClient()
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const importTemplate = getConfig().officials
  // While an import request runs (loading), every close path is a no-op: the
  // request may still be writing, and closing would hide how it ended.
  const onToggle = () => {
    if (loading) {
      return
    }
    setIsOpen(!isOpen)
  }

  // Every outcome may have added officials (a 409 can still import some rows),
  // so the game officials picker's cached directory goes stale with the list.
  const handleSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.adminOfficialSearch.all,
    })
    onSuccess?.()
  }

  const handleEsc = useCallback(
    (event) => {
      if (event.key === 'Escape' && !loading) {
        setIsOpen(false)
      }
    },
    [loading]
  )

  useEffect(() => {
    window.addEventListener('keydown', handleEsc)
    return () => {
      window.removeEventListener('keydown', handleEsc)
    }
  }, [handleEsc])

  const link = (
    <BaseActionButton
      name={'upload'}
      title={importTemplate?.label}
      onClick={onToggle}
      disabled={loading}
      busy={loading}
    />
  )

  return (
    <>
      {link}
      <Modal
        isOpen={isOpen}
        onClose={onToggle}
        shouldCloseOnOverlayClick={false}
      >
        {isOpen && (
          <ImportOfficialsContent
            setLoading={setLoading}
            loading={loading}
            toggle={onToggle}
            importTemplate={importTemplate}
            teamName={teamName}
            teamRosterId={teamRosterId}
            teamId={teamId}
            onSuccess={handleSuccess}
            entityType={entityType}
            entityId={entityId}
          />
        )}
      </Modal>
    </>
  )
}

export default ImportOfficials
